import Image from "next/image";

import { AppDownloadLink } from "@/components/app-download-link";
import { ANDROID_PLAY_STORE_URL } from "@/constants/app-store";

/** Google Play strip shared by the homepage and every signed-in page. */
export function AppStoreBanner() {
  return (
    <div className="border-b border-blue-100 bg-blue-50 print:hidden" data-print-hide>
      <div className="mx-auto flex w-full max-w-4xl items-center justify-center gap-3 px-4 py-2.5 sm:py-3">
        <p className="hidden whitespace-nowrap text-sm font-semibold text-gray-900 sm:block sm:text-base">
          CertLynx is on Google Play!
        </p>
        <AppDownloadLink
          href={ANDROID_PLAY_STORE_URL}
          store="google_play"
          className="inline-block shrink-0"
        >
          <Image
            src="/google-play-badge.png"
            alt="Get it on Google Play"
            width={646}
            height={250}
            className="h-12 w-auto sm:h-11"
          />
        </AppDownloadLink>
        <p className="whitespace-nowrap text-sm font-bold text-gray-900 sm:text-base">
          iOS Coming Soon
        </p>
      </div>
    </div>
  );
}
